<script>
    import { createEventDispatcher } from "svelte/internal";

    const dispatch = createEventDispatcher();
</script>


<button
    class="item"
    class:has-icon={$$slots.icon}
    class:has-text={$$slots.default}
    on:click|stopPropagation={(e) => {dispatch("click", e)}}
    >
    {#if $$slots.icon}
        <span class="icon">
            <slot name="icon"></slot>
        </span>
    {/if}
    {#if $$slots.default}
        <span class="text">
            <slot></slot>
        </span>    
    {/if}
</button>


<style>
    .item {
        position: relative;
        /* background-color: #F5F2EF; */
        background-color: #F5F2EF44;
        border: 2px dashed #ebe6e2;
        border: 2px dashed #e2ddd8;
        /* color: #333;
        color: rgba(0, 0, 0, 0.8); */
        color: #bbb5af;
        border-radius: 0.5rem;
        margin-bottom: 1rem;
        padding: 1rem;
        display: flex;
        justify-content: center;
        gap: 1rem;
        align-items: center;
        transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
        cursor: pointer;
        text-decoration: none;
    }

    .item:hover {
        border-radius: 20px;
        border: 2px solid #87C777;
        border: 2px dashed #87C777;
        /* border: 2px dashed #ebe6e2; */
        background-color: #F5F2EF;
        background-color: #87C77733;
        color: rgba(0, 0, 0, 0.8);
        color: #87C777;
        /* background-color: #87C777; */

        /* background-color: #ebe6e2; */
    }

    /* button {
        z-index: 1;
        background-color: transparent;
        border-radius: 9999rem;
        padding: 0.75rem;
        padding: 0.75rem;
        position: relative;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.8);
        font-size: 1rem;
        line-height: 1rem;
    } */


    /* ICONS */
    /* button.has-text {
        padding: 0.75rem 1.5rem;
    } */

    /* .icon {
        display: inline-block;
        width: 1rem;
        height: 1rem;
    }

    .has-text.has-icon > .icon {
        margin-left: -0.3rem;
        margin-right: 0.2rem;
    }
     */
    
    :global(.item.has-icon svg) {
        width: 2rem !important;
        height: 2rem;
    }
</style>